module.exports = __webpack_public_path__ + "static/media/medium-final.746c344d.svg";